import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/images/webforyou.svg';

const Header = () => {
  const { currentUser, isAdmin } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-2">
            <img src={logo} alt="WebForYou Support" className="h-8 w-auto" />
          </Link>

          {/* Mobil menü gomb */}
          <button
            className="md:hidden p-2 text-gray-400 hover:text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>

          {/* Navigációs menü */}
          <div className={`
            fixed inset-0 z-50 bg-gray-900/95 backdrop-blur-sm transform transition-transform duration-300 ease-in-out
            ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}
            md:relative md:inset-auto md:bg-transparent md:backdrop-blur-none md:transform-none md:translate-x-0 md:block
          `}>
            <div className="h-full md:h-auto">
              <div className="flex justify-end p-4 md:hidden">
                <button
                  onClick={() => setIsMenuOpen(false)}
                  className="text-gray-400 hover:text-white"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <nav className="flex flex-col items-center justify-center h-[calc(100%-5rem)] md:h-auto">
                <ul className="flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-4">
                  <li className="w-full md:w-auto px-4 md:px-0">
                    <Link 
                      to="/" 
                      onClick={() => setIsMenuOpen(false)}
                      className="inline-flex w-full justify-center items-center px-6 py-2.5 rounded-[30px] bg-gradient-to-r from-fuchsia-500 to-violet-500 hover:from-fuchsia-600 hover:to-violet-600 text-white text-base font-medium transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                    >
                      Kezdőlap
                    </Link>
                  </li>
                  <li className="w-full md:w-auto px-4 md:px-0">
                    <Link 
                      to="/nis2"
                      onClick={() => setIsMenuOpen(false)}
                      className="inline-flex w-full justify-center items-center px-6 py-2.5 rounded-[30px] bg-gradient-to-r from-fuchsia-500 to-violet-500 hover:from-fuchsia-600 hover:to-violet-600 text-white text-base font-medium transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                    >
                      NIS 2
                    </Link>
                  </li>
                  <li className="w-full md:w-auto px-4 md:px-0">
                    <Link 
                      to="/tudnivalok"
                      onClick={() => setIsMenuOpen(false)}
                      className="inline-flex w-full justify-center items-center px-6 py-2.5 rounded-[30px] bg-gradient-to-r from-fuchsia-500 to-violet-500 hover:from-fuchsia-600 hover:to-violet-600 text-white text-base font-medium transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                    >
                      Tudnivalók
                    </Link>
                  </li>
                  <li className="w-full md:w-auto px-4 md:px-0">
                    <Link 
                      to="/kapcsolat"
                      onClick={() => setIsMenuOpen(false)}
                      className="inline-flex w-full justify-center items-center px-6 py-2.5 rounded-[30px] bg-gradient-to-r from-fuchsia-500 to-violet-500 hover:from-fuchsia-600 hover:to-violet-600 text-white text-base font-medium transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                    >
                      Kapcsolat
                    </Link>
                  </li>
                  <li className="w-full md:w-auto px-4 md:px-0">
                    {isAdmin ? (
                      <Link 
                        to="/admin"
                        onClick={() => setIsMenuOpen(false)}
                        className="inline-flex w-full justify-center items-center px-6 py-2.5 rounded-[30px] bg-gradient-to-r from-fuchsia-500 to-violet-500 hover:from-fuchsia-600 hover:to-violet-600 text-white text-base font-medium transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                      >
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                        </svg>
                        <span>Admin</span>
                      </Link>
                    ) : (
                      <Link 
                        to="/login"
                        onClick={() => setIsMenuOpen(false)}
                        className="inline-flex w-full justify-center items-center px-6 py-2.5 rounded-[30px] bg-gradient-to-r from-fuchsia-500 to-violet-500 hover:from-fuchsia-600 hover:to-violet-600 text-white text-base font-medium transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                      >
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <span>Admin</span>
                      </Link>
                    )}
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 